import React from 'react';
import ClaimGroupClaimListShared from 'src/pages/shared/claim_group/overview/ClaimGroupClaimListShared';
const ClaimGroupClaimList = _ref => {
  let {
    handleToaster,
    accountType,
    loading,
    claimGroup,
    company,
    currentClaimCostId,
    onClaimGroupUpdate,
    sendClientCostEmail,
    handleImportCostTemplate,
    createChangeSetsForAllClaimsInClaimGroup,
    finalizeChangeSet,
    approveChangeSet,
    rejectChangeSet
  } = _ref;
  return /*#__PURE__*/React.createElement(ClaimGroupClaimListShared, {
    handleToaster: handleToaster,
    accountType: accountType,
    loading: loading,
    claimGroup: claimGroup,
    company: company,
    currentClaimCostId: currentClaimCostId,
    onClaimGroupUpdate: onClaimGroupUpdate,
    sendClientCostEmail: sendClientCostEmail,
    handleImportCostTemplate: handleImportCostTemplate,
    createChangeSetsForAllClaimsInClaimGroup: createChangeSetsForAllClaimsInClaimGroup,
    finalizeChangeSet: finalizeChangeSet,
    approveChangeSet: approveChangeSet,
    rejectChangeSet: rejectChangeSet
  });
};
export default ClaimGroupClaimList;